module.exports = __webpack_public_path__ + "img/foodforstudents-logo.f7c2e6cc.png";